import React, { useContext } from 'react'
import { UserContext } from '@/App'
import './styles.scss'

export default function OnboardingButton() {
	const { tasks } = useContext(UserContext)
	const onboardingTasks = tasks?.flatMap(group => group.tasks) || []
	const completedTasks = onboardingTasks.filter(task => task.completed).length
	const ctaText = completedTasks === 0
		? 'Starta guiden'
		: completedTasks === onboardingTasks.length
			? 'Visa guiden'
			: 'Fortsätt guiden'

	return (
		<a
			className='onboarding-cta'
			href='#!/onboard'
		>
			<span className='onboarding-cta-icon'>
				<i className='fas fa-rocket' />
			</span>
			<span className='onboarding-cta-label'>{ctaText}</span>
			<i className='fas fa-chevron-right onboarding-cta-arrow' />
		</a>
	)
}

